import { all, fork } from 'redux-saga/effects';
import { watchForSignIn } from './sagas/signInSaga';
import { watchForSendPasswordReset } from './sagas/sendPasswordResetSaga';
import { watchForRegister } from './sagas/registerSaga';
import { watchForSendChangePassword } from './sagas/sendChangePasswordSaga';
import { watchForUpdateProfile } from './sagas/updateProfileSaga';
import { watchForGetProfile } from './sagas/getProfileSaga';
import { watchForGetResourceData } from './sagas/getResourceDataSaga';
import { watchForSetResults } from './sagas/updateResultsSaga';
import { watchForSignOut } from 'redux/sagas/signOutSaga';
import { watchForUserSignedIn } from 'redux/sagas/userSignedInSaga';
import { watchForInitializeApp } from 'redux/appInit/sagas';
import { watchForUpdateResourceActivity } from './sagas/updateResourceActivitySaga';
import { watchForSendNewPasswordWithResetToken } from './sagas/sendNewPasswordWithResetTokenSaga';
import {
  watchForAutoSaveCheckInStatus,
  watchForLoadCheckInStatus,
  watchForSubmitSurvey,
} from 'redux/checkIn/sagas';
import { watchForUpdateRecommendedResource } from './sagas/updateRecommendedResourceSaga';
import { watchForGetQuestionnaireResponse } from './sagas/questionnaireResponseSaga';
import { watchForClientAnalytics } from './sagas/clientAnalyticsSaga';
import { watchForUpdateQuestionnaireResponse } from './sagas/updateQuestionnaireResponseSaga';
import { watchForGetValidateToken } from './sagas/validateTokenSaga';

export default function* rootSaga() {
  yield all([
    fork(watchForInitializeApp),
    fork(watchForSignIn),
    fork(watchForUserSignedIn),
    fork(watchForSignOut),
    fork(watchForSendPasswordReset),
    fork(watchForRegister),
    fork(watchForSendChangePassword),
    fork(watchForGetProfile),
    fork(watchForUpdateProfile),
    fork(watchForGetResourceData),
    fork(watchForSetResults),
    fork(watchForUpdateResourceActivity),
    fork(watchForSendNewPasswordWithResetToken),
    fork(watchForLoadCheckInStatus),
    fork(watchForUpdateRecommendedResource),
    fork(watchForGetQuestionnaireResponse),
    fork(watchForSubmitSurvey),
    fork(watchForAutoSaveCheckInStatus),
    fork(watchForClientAnalytics),
    fork(watchForUpdateQuestionnaireResponse),
    fork(watchForGetValidateToken),
  ]);
}
